export const isGiftAccountClarificationOn = () => {
  let decodedUrl = ''
  try {
    decodedUrl = decodeURIComponent(window.location.search)
  } catch (e) {
    console.error(e)
  }

  return decodedUrl.includes('utm_campaign=GiftDelivery')
}

export const isLoginModalOpened = () =>
  document.getElementsByClassName('authentication-modal').length > 0
